/**
 * Expandable Table
 *
 * @module
 */

import { up } from '../../../utilities/QuerySelectors.js';

export class ExpandableTable {
    /**
     * Limit the number of rows displayed in a table, but show all on button click.
     *
     * @param {Element} table
     */
    constructor(table) {
        this.table = table;
        this.container = up(table, '.financial-table-section');
        this.lastRow = table.querySelector('tbody').lastElementChild;
        this.delay = 0;
    }

    /**
     * Show all the rows in the table.
     *
     * @private
     * @return {void}
     */
    expand() {
        console.log('ExpandableTable.expand', this.table);

        if (this.delay === 0) {
            return this.onExpansion();
        }

        this.container.classList.add('table-expanding');

        if (typeof this.delay === 'number' && this.delay !== 0) {
            setTimeout(() => this.onExpansion(), 2000);
            return;
        }

        // do not allow an infinite loading state due to misconfiguration.
        this.onExpansion();
        console.error('Invalid expandable table delay', this.delay);
    }

    /**
     * Update the CSS classes to display the whole table and trigger content update event.
     *
     * @private
     * @return {void}
     */
    onExpansion() {
        this.container.classList.remove('table-expanding');
        this.container.classList.add('table-expanded');
        setTimeout(() => this.table.dispatchEvent(new Event('htmlchange')), 1000);
    }

    /**
     * Set a constant duration for the expanding state.
     *
     * @param {number} delay
     * @return {void}
     */
    setConstantDelay(delay) {
        this.delay = delay;
    }

    /**
     * Initialize the expanding feature.
     *
     * @return {void}
     */
    init() {
        if (!this.container) {
            this.container = this.table.parentElement;
        }
        const btn = this.container.querySelector('.expand-table-btn, .show-more-button');
        console.log('ExpandableTable.init', this.table, btn);
        if (!btn) {
            return;
        }
        btn.addEventListener('click', () => this.expand());
    }
}
